import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import {
  Flex,
  Heading,
  Box,
  Text,
  Link,
  UnorderedList,
  ListItem,
} from "@chakra-ui/react";

import { useLocation } from "react-router-dom";
import { Waypoint } from "react-waypoint";

//images
import bg from "../../assets/images/3.jpg";

const area1 = require("../../assets/images/area1.jpg");
const area2 = require("../../assets/images/area2.jpg");
const area3 = require("../../assets/images/area3.jpg");
const area4 = require("../../assets/images/area4.jpg");
const area5 = require("../../assets/images/Deep_water_FlowAssurance5.jpeg");
const area6 = require("../../assets/images/area6.jpg");
const area7 = require("../../assets/images/area7.jpg");
const area8 = require("../../assets/images/Process_Engineering_Oil&gas.jpeg");

const Business = () => {
  let params = useLocation();
  useEffect(() => {
    if (params?.state?.id)
      document.querySelector(`${params.state.id}`).scrollIntoView(true);
    else window.scrollTo(0, 0);
  }, [params.state, useLocation().state]);

  return (
    <Flex flexDir={"column"} alignItems={"center"}>
      <Helmet>
        <title>AKIA | Business</title>
        <meta
          name="keywords"
          content="All Kind of PFD and P&ID and Multidiscipline Drafting by Akia"
        />
        <meta
          title="Business - Best Consultant for Multidiscipline Equipment Design"
          content="Get multidiscipline engineering study & analysis, get all kinds of Pfd & p&id, multidiscipline drafting with process design of compressor system & equipment."
        />
        <meta
          name="keywords"
          content="Process Design of Compressor System and Equipment"
        />
        <meta
          name="keywords"
          content="Consult Akia for Multidiscipline Engineering Study and Analysis"
        />
        <meta
          name="keywords"
          content="Best Consultant for Multidiscipline Equipment Design"
        />
      </Helmet>
      <Flex
        bg={`linear-gradient(rgba(0, 0, 0, 0.82), rgba(0, 0, 0, 0.82)), url(${bg})`}
        backgroundSize={"cover"}
        backgroundPosition={"bottom"}
        h={"100vh"}
        w="100vw"
        alignItems={"center"}
        justifyContent={"center "}
        color={"whiteAlpha.900"}
      >
        <Box
          transform={{
            base: "",
            md: "translateX(-10vw)",
            lg: "translateX(-15vw)",
          }}
          px={"4rem"}
        >
          <Flex
            overflow={"hidden"}
            maxW={"100rem"}
            pos={"relative"}
            overflowX={"hidden"}
            w={"fit-content"}
          >
            <Waypoint
              onEnter={() =>
                (document.querySelector("#animateMain5").style.animation =
                  "heading 1.5s ease")
              }
            >
              <Flex id="animateMain5">
                <Heading
                  fontSize={{ base: "3.7rem", "3sm": "4.5rem", lg: "5.5rem" }}
                  textTransform={"uppercase"}
                  fontFamily={"Roboto Condensed, Lato, Sans-serif"}
                  flexShrink={"0"}
                  w={"fit-content"}
                >
                  Our Services
                </Heading>
                <Box
                  w={"100%"}
                  h={"100%"}
                  bg={"whiteAlpha.900"}
                  flexShrink={"0"}
                />
              </Flex>
            </Waypoint>
          </Flex>
          <Flex
            overflow={"hidden"}
            maxW={"100rem"}
            pos={"relative"}
            overflowX={"hidden"}
            w={"fit-content"}
            mt={"1rem"}
          >
            <Waypoint
              onEnter={() =>
                (document.querySelector("#animateMain6").style.animation =
                  "heading 1.5s ease")
              }
            >
              <Flex id="animateMain6">
                <Text
                  textAlign={{ base: "justify", md: "left" }}
                  flexShrink={0}
                  fontSize={"1.8rem"}
                  maxW={"50rem"}
                  w={"fit-content"}
                >
                  A multi-disciplinary Engineering design firm with competent
                  and full expertise in Offshore and onshore Oil and Gas,
                  Petrochemical and Water Treatment Plant Engineering
                </Text>
                <Box
                  w={"100%"}
                  h={"100%"}
                  bg={"whiteAlpha.900"}
                  flexShrink={"0"}
                />
              </Flex>
            </Waypoint>
          </Flex>
        </Box>
      </Flex>

      {/* Next Section */}
      <Flex
        width={"100%"}
        px={{ base: "5rem", xl: "8rem" }}
        py={"5rem"}
        flexDir={"column"}
        alignItems={"center"}
      >
        <Flex
          overflow={"hidden"}
          maxW={"100rem"}
          pos={"relative"}
          overflowX={"hidden"}
          w={"fit-content"}
        >
          <Waypoint
            onEnter={() =>
              (document.querySelector("#animated24").style.animation =
                "heading 1.5s ease")
            }
          >
            <Flex id="animated24">
              <Heading
                flexShrink={0}
                fontSize={{ base: "3rem", "3sm": "4rem", lg: "5rem" }}
                textTransform={"uppercase"}
              >
                Our Services
              </Heading>
              <Box w={"100%"} h={"100%"} bg={"black"} flexShrink={"0"} />
            </Flex>
          </Waypoint>
        </Flex>
        <Box bg={"#EA0F0F"} h="5px" w={"10rem"} mt={"2.5rem"}></Box>

        <Flex
          flexDir={{ base: "column-reverse", md: "row" }}
          gap={"2rem"}
          width={"100%"}
          mt={"5rem"}
          maxW={"1440px"}
        >
          <Flex
            flexDirection={"column"}
            flex={"0 1 50%"}
            justifyContent={"center"}
          >
            <Flex
              overflow={"hidden"}
              maxW={"100rem"}
              pos={"relative"}
              overflowX={"hidden"}
              w={"fit-content"}
              mb={"1.5rem"}
            >
              <Waypoint
                onEnter={() =>
                  (document.querySelector("#process").style.animation =
                    "heading 1.5s ease")
                }
              >
                <Flex id="process">
                  <Heading width={"100%"} flexShrink={0} fontSize={"3.2rem"}>
                    Process Engineering
                  </Heading>
                  <Box w={"100%"} h={"100%"} bg={"black"} flexShrink={"0"} />
                </Flex>
              </Waypoint>
            </Flex>
            <Box bg={"#EA0F0F"} h="5px" w={"6rem"} mb={"1.5rem"}></Box>
            <UnorderedList
              fontSize={{ base: "1.5rem", lg: "1.65rem", xl: "1.8rem" }}
            >
              <ListItem>Process Simulation using Aspen HYSYS</ListItem>
              <ListItem>
                Steady state hydraulic analysis of single and multiphase piping
              </ListItem>
              <ListItem>
                Preparation of PFD, P&ID, Heat and Material Balance (HMB), and C
                & E diagrams
              </ListItem>
              <ListItem>
                Equipment sizing- Two phase and Three phase Separator sizing,
                KOD Sizing etc
              </ListItem>
              <ListItem>PSV Sizing</ListItem>
              <ListItem>
                Flare system design and Flare network hydraulics using FLARENET
              </ListItem>
              <ListItem>Blowdown/Depressurization calculation </ListItem>
              <ListItem>Flare radiation calculation</ListItem>
              <ListItem>
                Water network hydraulic analysis using Water CAD/ Water GEMS
              </ListItem>
              <ListItem>
                Developing Process datasheet for equipment and Instruments
              </ListItem>
              <ListItem>Developing Process Engineering Documents</ListItem>
              <ListItem>Utility Demand calculation</ListItem>
            </UnorderedList>
           <Text mt={"1.5rem"}fontWeight={'bold'} fontSize={{ base: "1.8rem", md: "2rem", lg: "2.2rem" }}>
  For more specialized service details for this discipline , please visit{" "}
  <Link
    href="https://www.akiaflowassurance.com"
    color="blue.500"
    isExternal
  >
    www.akiaflowassurance.com
  </Link>
</Text>
          </Flex>
          <Waypoint
            onEnter={() =>
              (document.querySelector("#animate16").style.animation =
                "fadeUp 1.5s")
            }
          >
            <Box
              id="animate16"
              flex={{ base: "0 1 350px", md: "0 1 50%" }}
              bg={`url(${area8})`}
              bgPos={"center"}
              bgSize={"cover"}
              height={"500px"}
            ></Box>
          </Waypoint>
        </Flex>

        <Flex
          flexDir={{ base: "column", md: "row" }}
          gap={"2rem"}
          width={"100%"}
          mt={"5rem"}
          maxW={"1440px"}
        >
          <Waypoint
            onEnter={() =>
              (document.querySelector("#animate17").style.animation =
                "fadeUp 1.5s")
            }
          >
            <Box
              id="animate17"
              flex={{ base: "0 1 350px", md: "0 1 50%" }}
              bg={`url(${area1})`}
              bgPos={"center"}
              bgSize={"cover"}
              height={"500px"}
            ></Box>
          </Waypoint>
          <Flex
            flexDirection={"column"}
            flex={"0 1 50%"}
            justifyContent={"center"}
            ml={{ base: "0rem", md: "5rem", "1.5xl": "10rem" }}
          >
            <Flex
              overflow={"hidden"}
              maxW={"100rem"}
              pos={"relative"}
              overflowX={"hidden"}
              w={"fit-content"}
              mb={"1.5rem"}
            >
              <Waypoint
                onEnter={() =>
                  (document.querySelector("#piping").style.animation =
                    "heading 1.5s ease")
                }
              >
                <Flex id="piping">
                  <Heading width={"100%"} flexShrink={0} fontSize={"3.2rem"}>
                    Piping Engineering
                  </Heading>
                  <Box w={"100%"} h={"100%"} bg={"black"} flexShrink={"0"} />
                </Flex>
              </Waypoint>
            </Flex>
            <Box bg={"#EA0F0F"} h="5px" w={"6rem"} mb={"1.5rem"}></Box>
            <UnorderedList
              fontSize={{ base: "1.5rem", lg: "1.65rem", xl: "1.8rem" }}
            >
              <ListItem>Equipment Layout</ListItem>
              <ListItem>Piping Layout</ListItem>
              <ListItem>Isometric Drawings.</ListItem>
              <ListItem>Pipe wall thickness calculation</ListItem>
              <ListItem>Piping support design</ListItem>
              <ListItem>Valve Datasheet</ListItem>
              <ListItem>Material Take-off (MTO)</ListItem>
            </UnorderedList>
          </Flex>
        </Flex>

        <Flex
          flexDir={{ base: "column-reverse", md: "row" }}
          gap={"2rem"}
          width={"100%"}
          mt={"5rem"}
          maxW={"1440px"}
        >
          <Flex
            flexDirection={"column"}
            flex={"0 1 50%"}
            justifyContent={"center"}
          >
            <Flex
              overflow={"hidden"}
              maxW={"100rem"}
              pos={"relative"}
              overflowX={"hidden"}
              w={"fit-content"}
              mb={"1.5rem"}
            >
              <Waypoint
                onEnter={() =>
                  (document.querySelector("#mechanical").style.animation =
                    "heading 1.5s ease")
                }
              >
                <Flex id="mechanical">
                  <Heading width={"100%"} flexShrink={0} fontSize={"3.2rem"}>
                    Mechanical Engineering
                  </Heading>
                  <Box w={"100%"} h={"100%"} bg={"black"} flexShrink={"0"} />
                </Flex>
              </Waypoint>
            </Flex>
            <Box bg={"#EA0F0F"} h="5px" w={"6rem"} mb={"1.5rem"}></Box>
            <UnorderedList
              fontSize={{ base: "1.5rem", lg: "1.65rem", xl: "1.8rem" }}
            >
              <ListItem>Heat Exchangers</ListItem>
              <ListItem>API Storage Tanks</ListItem>
              <ListItem>Pressure Vessels</ListItem>
              <ListItem>Towers and columns</ListItem>
              <ListItem>
                Material handling equipment like conveyors, elevators etc
              </ListItem>
            </UnorderedList>
          </Flex>{" "}
          <Waypoint
            onEnter={() =>
              (document.querySelector("#animate18").style.animation =
                "fadeUp 1.5s")
            }
          >
            <Box
              id="animate18"
              flex={{ base: "0 1 350px", md: "0 1 50%" }}
              bg={`url(${area2})`}
              bgPos={"center"}
              bgSize={"cover"}
              height={"500px"}
            ></Box>
          </Waypoint>
        </Flex>

        <Flex
          flexDir={{ base: "column", md: "row" }}
          gap={"2rem"}
          width={"100%"}
          mt={"5rem"}
          maxW={"1440px"}
        >
          <Waypoint
            onEnter={() =>
              (document.querySelector("#animate19").style.animation =
                "fadeUp 1.5s")
            }
          >
            <Box
              id="animate19"
              flex={{ base: "0 1 350px", md: "0 1 50%" }}
              bg={`url(${area3})`}
              bgPos={"center"}
              bgSize={"cover"}
              height={"500px"}
            ></Box>
          </Waypoint>
          <Flex
            flexDirection={"column"}
            flex={"0 1 50%"}
            justifyContent={"center"}
            ml={{ base: "0rem", md: "5rem", "1.5xl": "10rem" }}
          >
            <Flex
              overflow={"hidden"}
              maxW={"100rem"}
              pos={"relative"}
              overflowX={"hidden"}
              w={"fit-content"}
              mb={"1.5rem"}
            >
              <Waypoint
                onEnter={() =>
                  (document.querySelector("#instrumentation").style.animation =
                    "heading 1.5s ease")
                }
              >
                <Flex id="instrumentation">
                  <Heading width={"100%"} flexShrink={0} fontSize={"3.2rem"}>
                    Instrumental Engineering
                  </Heading>
                  <Box w={"100%"} h={"100%"} bg={"black"} flexShrink={"0"} />
                </Flex>
              </Waypoint>
            </Flex>
            <Box bg={"#EA0F0F"} h="5px" w={"6rem"} mb={"1.5rem"}></Box>
            <UnorderedList
              fontSize={{ base: "1.5rem", lg: "1.65rem", xl: "1.8rem" }}
            >
              <ListItem>Instrument index and I/O list</ListItem>
              <ListItem>Loop diagrams</ListItem>
              <ListItem>Junction box schedule and wiring diagrams</ListItem>
              <ListItem>Creation of Instrument Tags & loops</ListItem>
              <ListItem>Developing Instrument specification sheets</ListItem>
            </UnorderedList>
          </Flex>
        </Flex>

        <Flex
          flexDir={{ base: "column-reverse", md: "row" }}
          gap={"2rem"}
          width={"100%"}
          mt={"5rem"}
          maxW={"1440px"}
        >
          <Flex
            flexDirection={"column"}
            flex={"0 1 50%"}
            justifyContent={"center"}
          >
            <Flex
              overflow={"hidden"}
              maxW={"100rem"}
              pos={"relative"}
              overflowX={"hidden"}
              w={"fit-content"}
              mb={"1.5rem"}
            >
              <Waypoint
                onEnter={() =>
                  (document.querySelector("#electrical").style.animation =
                    "heading 1.5s ease")
                }
              >
                <Flex id="electrical">
                  <Heading
                    width={"100%"}
                    flexShrink={0}
                    fontSize={"3.2rem"}
                    mb={"1.5rem"}
                  >
                    Electrical Engineering
                  </Heading>
                  <Box w={"100%"} h={"100%"} bg={"black"} flexShrink={"0"} />
                </Flex>
              </Waypoint>
            </Flex>
            <Box bg={"#EA0F0F"} h="5px" w={"6rem"} mb={"1.5rem"}></Box>
            <UnorderedList
              fontSize={{ base: "1.5rem", lg: "1.65rem", xl: "1.8rem" }}
            >
              <ListItem>Load Analysis </ListItem>
              <ListItem>Cable schedules and Bill of Materials</ListItem>
              <ListItem>Preparing Electrical Drawings</ListItem>
              <ListItem>Developing Electrical equipment data sheets.</ListItem>
              <ListItem>Fault level calculations </ListItem>
              <ListItem>
                Estimation of plant demand and sizing of the transformers
              </ListItem>
            </UnorderedList>
          </Flex>
          <Waypoint
            onEnter={() =>
              (document.querySelector("#animate20").style.animation =
                "fadeUp 1.5s")
            }
          >
            <Box
              id="animate20"
              flex={{ base: "0 1 350px", md: "0 1 50%" }}
              bg={`url(${area6})`}
              bgPos={"center"}
              bgSize={"cover"}
              height={"500px"}
            ></Box>
          </Waypoint>
        </Flex>

        <Flex
          flexDir={{ base: "column", md: "row" }}
          gap={"2rem"}
          width={"100%"}
          mt={"5rem"}
          maxW={"1440px"}
        >
          <Waypoint
            onEnter={() =>
              (document.querySelector("#animate21").style.animation =
                "fadeUp 1.5s")
            }
          >
            <Box
              id="animate21"
              flex={{ base: "0 1 350px", md: "0 1 50%" }}
              bg={`url(${area4})`}
              bgPos={"center"}
              bgSize={"cover"}
              height={"500px"}
            ></Box>
          </Waypoint>
          <Flex
            flexDirection={"column"}
            flex={"0 1 50%"}
            justifyContent={"center"}
            ml={{ base: "0rem", md: "5rem", "1.5xl": "10rem" }}
          >
            <Flex
              overflow={"hidden"}
              pos={"relative"}
              overflowX={"hidden"}
              w={"fit-content"}
              mb={"1.5rem"}
            >
              <Waypoint
                onEnter={() =>
                  (document.querySelector("#civil").style.animation =
                    "heading 1.5s ease")
                }
              >
                <Flex width={"100%"} id="civil">
                  <Heading
                    width={"100%"}
                    flexShrink={0}
                    fontSize={"3.2rem"}
                    mb={"1.5rem"}
                  >
                    Civil and Structural Engineering
                  </Heading>
                  <Box w={"100%"} bg={"black"} flexShrink={"0"} />
                </Flex>
              </Waypoint>
            </Flex>
            <Box bg={"#EA0F0F"} h="5px" w={"6rem"} mb={"1.5rem"}></Box>
            <UnorderedList
              fontSize={{ base: "1.5rem", lg: "1.65rem", xl: "1.8rem" }}
              maxW={"80%"}
            >
              <ListItem>
                Structural Analysis and design for Steel and concrete structures
              </ListItem>
              <ListItem>Concrete Foundation Design</ListItem>
              <ListItem>Bar Bending Schedule.</ListItem>
              <ListItem>
                Preparing Structural/Civil general arrangement drawings
              </ListItem>
              <ListItem> Connection details & Material Take Off</ListItem>
            </UnorderedList>
          </Flex>
        </Flex>

        <Flex
          flexDir={{ base: "column-reverse", md: "row" }}
          gap={"2rem"}
          width={"100%"}
          mt={"5rem"}
          maxW={"1440px"}
        >
          <Flex
            flexDirection={"column"}
            flex={"0 1 50%"}
            justifyContent={"center"}
          >
            <Flex
              overflow={"hidden"}
              maxW={"100rem"}
              pos={"relative"}
              overflowX={"hidden"}
              w={"fit-content"}
              mb={"1.5rem"}
            >
              <Waypoint
                onEnter={() =>
                  (document.querySelector("#flow").style.animation =
                    "heading 1.5s ease")
                }
              >
                <Flex id="flow">
                  <Heading
                    width={"100%"}
                    flexShrink={0}
                    fontSize={"3.2rem"}
                    mb={"1.5rem"}
                  >
                    Flow Assurance Engineering
                  </Heading>
                  <Box w={"100%"} h={"100%"} bg={"black"} flexShrink={"0"} />
                </Flex>
              </Waypoint>
            </Flex>
            <Box bg={"#EA0F0F"} h="5px" w={"6rem"} mb={"1.5rem"}></Box>
            <UnorderedList
              maxW={"80%"}
              fontSize={{ base: "1.5rem", lg: "1.65rem", xl: "1.8rem" }}
            >
              <ListItem>Fluid Analysis using PVTSIM/Multiflash</ListItem>
              <ListItem>
                Steady-state and Transient analysis of single and multiphase
                flow using OLGA, PIPESIM, PIPENET
              </ListItem>
              <ListItem>Pressure drop calculation and pipeline sizing</ListItem>
              <ListItem>
                Operating flow regime determination over field-life
              </ListItem>
              <ListItem>Production shutdown/cooldown study</ListItem>
              <ListItem>Pipeline blowdown/depressurization study</ListItem>
              <ListItem>Production start-up analysis</ListItem>
              <ListItem>Slugging study and Pigging Analysis </ListItem>
              <ListItem>Hydrate formation and wax precipitation study</ListItem>
              <ListItem>
                Developing Process datasheet for equipment and Instruments
              </ListItem>
              <ListItem>
                Overpressure Protection Studies – Line pack, Water Hammer
              </ListItem>
            </UnorderedList>
           <Text mt={"1.5rem"} fontWeight={'bold'} fontSize={{ base: "1.8rem", md: "2rem", lg: "2.2rem" }}>
  For more specialized service details for this discipline, please visit{" "}
  <Link
    href="https://www.akiaflowassurance.com"
    color="blue.500"
    isExternal
  >
    www.akiaflowassurance.com
  </Link>
</Text>
          </Flex>
          <Waypoint
            onEnter={() =>
              (document.querySelector("#animate22").style.animation =
                "fadeUp 1.5s")
            }
          >
            <Box
              id="animate22"
              flex={{ base: "0 1 350px", md: "0 1 50%" }}
              bg={`url(${area5})`}
              bgPos={"center"}
              bgSize={"cover"}
              height={"500px"}
            ></Box>
          </Waypoint>
        </Flex>

        <Flex
          flexDir={{ base: "column", md: "row" }}
          gap={"2rem"}
          width={"100%"}
          mt={"5rem"}
          maxW={"1440px"}
        >
          <Waypoint
            onEnter={() =>
              (document.querySelector("#animate23").style.animation =
                "fadeUp 1.5s")
            }
          >
            <Box
              id="animate23"
              flex={{ base: "0 1 350px", md: "0 1 50%" }}
              bg={`url(${area7})`}
              bgPos={"center"}
              bgSize={"cover"}
              height={"500px"}
            ></Box>
          </Waypoint>
          <Flex
            flexDirection={"column"}
            flex={"0 1 50%"}
            justifyContent={"center"}
            ml={{ base: "0rem", md: "5rem", "1.5xl": "10rem" }}
          >
            <Flex
              overflow={"hidden"}
              pos={"relative"}
              overflowX={"hidden"}
              w={"fit-content"}
              mb={"1.5rem"}
              maxW={"80%"}
            >
              <Waypoint
                onEnter={() =>
                  (document.querySelector("#other").style.animation =
                    "heading 1.5s ease")
                }
              >
                <Flex width={"100%"} id="other">
                  <Heading flexShrink={0} fontSize={"3.2rem"} mb={"1.5rem"}>
                    Other Services
                  </Heading>
                  <Box w={"100%"} h={"100%"} bg={"black"} flexShrink={"0"} />
                </Flex>
              </Waypoint>
            </Flex>
            <Box bg={"#EA0F0F"} h="5px" w={"6rem"} mb={"1.5rem"}></Box>
            <UnorderedList
              fontSize={{ base: "1.5rem", lg: "1.65rem", xl: "1.8rem" }}
              maxW={"80%"}
            >
              <ListItem>
                As Building the Engineering Drawings based on red marked up
                drawings
              </ListItem>
            </UnorderedList>
          </Flex>
        </Flex>
      </Flex>
      <Flex
        width={"100vw"}
        alignItems={"center"}
        justifyContent={"space-evenly"}
        flexDirection={{ base: "column", md: "row" }}
        py={"6rem"}
      >
        <Heading
          textTransform={"uppercase"}
          fontWeight={"700"}
          fontSize={{ base: "2.5rem", md: "4rem" }}
        >
          Connect with us
        </Heading>
        <Flex alignItems={"center"} mt={{ base: "2rem", md: "0" }}>
          <a
                      id="phone"
                      style={{ flex: "0 0 22%" }}
                      href="https://wa.me/+971501232838"
                    >
                      
                        <Heading fontSize={"4rem"}>
                          <i
                            className="fa-brands fa-square-whatsapp"
                            style={{ color: "green" }}
                          />
                        </Heading>
                        
                        
                      
                    </a>

          <a href="https://www.linkedin.com/company/akia-flow-assurance/" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-linkedin"
            ></i>
          </a>

          <a href="https://www.youtube.com/@AKIAFlowAssurance" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-square-youtube"
            ></i>
          </a>



          <a href="https://www.facebook.com/AKIAFlowAssurance" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-square-facebook"
            ></i>
          </a>
          <a href="https://www.instagram.com/akiaflowassurance/" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-square-instagram"
            ></i>
          </a>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Business;
